import actions from './actions';
import mutations from './mutations';

const state = {
  features: {}
};

const getters = {
  isFeatureEnabled: (stateData) => (featureName) =>
    Object.prototype.hasOwnProperty.call(stateData.features, featureName)
      ? stateData.features[featureName]
      : false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
